<template>
  <div class="user-avatar" @click="handleClick">
    <div class="avatar-circle">
      <span class="initials">{{ initials }}</span>
    </div>
    <span class="user-name">{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: 'UserAvatar',
  props: {
    initials: {
      type: String,
      required: true,
      default: '',
    },
    name: {
      type: String,
      required: true,
      default: '',
    },
    onClick: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    handleClick(event) {
      this.onClick(event)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/light-theme-system-palette.scss';
@import '@/assets/css/variables.scss';

.user-avatar {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: $primary-container;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
}

.initials {
  color: $on-primary-container;
  text-align: center;
  /* Vasion/title/medium */
  font-family: $font-family-book;
  font-size: 16px;
  font-style: normal;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: 0.15px;
}

.user-name {
  color: $on-surface-variant;
  /* Vasion/label/large */
  font-family: $font-family-book;
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: 0.1px;
}
</style>
